import Axios from "axios";

import { customHistory } from "../App";
import SwalAlertComp from "../components/SwalAlert";
import { getTimezoneHeaders } from "../helpers/getClientTimezone";
import { handleSubscriptionNotFound } from "./helpers/subscription";

localStorage.setItem("isUnauth", false);

let interceptorsRegistered = false;

const AxiosAuthController = (props) => {
    if (interceptorsRegistered) {
        return;
    }
    interceptorsRegistered = true;

    Axios.interceptors.request.use((config) => {
        const timezoneHeaders = getTimezoneHeaders();
        config.headers = {
            ...config.headers,
            ...timezoneHeaders,
        };
        return config;
    });

    Axios.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;
            const response = err?.response;
            if (response) {
                // Access Token was expired
                if (
                    response.status === 401 &&
                    !originalConfig._retry &&
                    (localStorage?.isUnauth === "false" ||
                        localStorage?.isUnauth === undefined)
                ) {
                    localStorage.clear();
                    localStorage.setItem("isUnauth", true);
                    if (window.location.pathname !== "/login") {
                        localStorage.setItem("to", window.location.pathname);
                        localStorage.setItem("search", window.location.search);
                    }
                    localStorage.setItem("isUnauth", false);
                    SwalAlertComp({
                        title: "Failed",
                        message:
                            response?.data?.message ||
                            "You are unauthorized. Sign in again!",
                        icon: "error",
                        timer: 4000,
                    });
                    customHistory.push("/login");
                    return err;
                } else if (response.status === 403) {
                    handleSubscriptionNotFound(response);
                }
            }
            return Promise.reject(err);
        },
    );
};
export default AxiosAuthController;
